var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiClient } from '../interceptor/interceptor';
export const getEducationPDF = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (documentType = 'osa-education', locale = 'en-US') {
    const response = yield apiClient.get('/screener/documents/latest', {
        responseType: 'blob',
        params: {
            document_type: documentType,
            locale: locale
        },
        headers: {
            Accept: 'application/pdf'
        }
    });
    return response.data;
});
